import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {UpdateRolesAndHomepageType} from "./__graphql-types__/index.ts";

export type UserRole = "TEACHER" | "PARENT";
export type UserHomepage = "COACH" | "PARENT" | "LEARNER" | "DISTRICT_ADMIN";

const UPDATE_ROLES_AND_HOMEPAGE_MUTATION: GqlOperation<
    UpdateRolesAndHomepageType["response"],
    UpdateRolesAndHomepageType["variables"]
> = gqlOp(gql`
    mutation UpdateRolesAndHomepage(
        $roles: [UserRole]!
        $homepage: UserHomepage!
    ) {
        updateRolesAndHomepageSettings(roles: $roles, homepage: $homepage) {
            user {
                id
                isTeacher
                isParent
                homepageUrl
            }
            error {
                code
            }
        }
    }
`);

export const updateRolesAndHomepage = (
    gqlFetch: GqlFetchFn,
    roles: Array<UserRole>,
    homepage: UserHomepage,
): Promise<UpdateRolesAndHomepageType["response"]> => {
    return gqlFetch(UPDATE_ROLES_AND_HOMEPAGE_MUTATION, {
        variables: {
            roles,
            homepage,
        },
    })
        .then((data) => {
            if (data.updateRolesAndHomepageSettings?.error) {
                throw new KAError(
                    data.updateRolesAndHomepageSettings.error.code,
                    Errors.Internal,
                );
            }

            return data;
        })
        .catch((e) => {
            throw new KAError(
                "Failed to update roles and homepage",
                Errors.Internal,
                {cause: e},
            );
        });
};
